import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/apiClient";

const SettingsContext = createContext({});
export const useSettings = () => useContext(SettingsContext);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const load = () => api.get("/settings").then(({ data }) => setSettings(data || {})).catch(() => {});
  useEffect(() => {
    load();
    // Refetch when the tab regains focus so admin changes go live without republishing.
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onFocus);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onFocus);
    };
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}
